import type { ApiErrorCodeAndMessageKey } from './getErrorCodeAndMessage.types';

export const EMPTY_RETURN: ApiErrorCodeAndMessageKey = {
  errorCode: null,
  errorMessage: null,
};
